import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SystemInfoEffects, systemInfoReducer } from './store';
import { SystemInfoServiceModule } from 'app/core/services/system-info/system-info-service.module';

@NgModule({
  imports: [
    SystemInfoServiceModule,
    StoreModule.forFeature('systemInfo', systemInfoReducer),
    EffectsModule.forFeature([SystemInfoEffects]),
  ]
})
export class SystemInfoModule {}
